import toNumber from 'lodash/toNumber'
import { Map, fromJS } from 'immutable'
import {
  CLEAR_NOTIFICATION_ERROR,
  SET_NOTIFICATION_ERROR,
  SET_NOTIFICATIONS,
  SET_SUBSCRIPTIONS,
  SET_SUBSCRIPTION,
  SET_NOTIFICATION,
  SET_RESTRICTIONS,
  GET_RESTRICTIONS,
  SET_CONFIG,
} from './actions'

export const initialState = Map()

export default function notificationsReducer (state = initialState, action) {
  const { payload, type } = action
  switch (type) {
    case SET_CONFIG: {
      return state.set('config', fromJS(payload))
    }
    case GET_RESTRICTIONS: {
      return state.setIn(['restrictions', 'processing'], true)
        .deleteIn(['restrictions', 'contentId'])
        .deleteIn(['restrictions', 'data'])
    }
    case SET_RESTRICTIONS: {
      const { contentId, restrictions } = payload
      return state.setIn(['restrictions', 'processing'], false)
        .setIn(['restrictions', 'contentId'], toNumber(contentId))
        .setIn(['restrictions', 'data'], restrictions)
    }
    case SET_NOTIFICATION_ERROR: {
      const { err } = payload
      return state.set('error', err)
    }
    case CLEAR_NOTIFICATION_ERROR: {
      return state.delete('error')
    }
    case SET_SUBSCRIPTION: {
      const { data } = payload
      const { id } = data
      return state.setIn(['subscription', id], fromJS(data))
    }
    case SET_NOTIFICATION: {
      const { data } = payload
      const { id } = data
      return state.setIn(['notification', id], fromJS(data))
    }
    case SET_SUBSCRIPTIONS: {
      const { data } = payload
      const {
        total, p, pp, subscriptions,
      } = data
      return state.set('subscriptions', fromJS({
        p, pp, total, data: subscriptions,
      }))
    }
    case SET_NOTIFICATIONS: {
      const { data } = payload
      const {
        total, p, pp, notifications,
      } = data
      return state.set('notifications', fromJS({
        p, pp, total, data: notifications,
      }))
    }
    default:
      return state
  }
}
